import type { Dayjs } from "dayjs";

export const isWeekend = (lang: string, date: Dayjs): boolean => {
  switch (lang) {
    case "en": {
      return date.weekday() === 5 || date.weekday() === 6;
    }
    case "ru": {
      return date.weekday() === 5 || date.weekday() === 6;
    }
    default: {
      return date.weekday() === 5 || date.weekday() === 6;
    }
  }
};
